import logo from "@/assets/LOGO-RETRO-IA.png";

export default function Footer() {
  return (
    <div className="mt-auto flex justify-center items-center p-8">
      <img src={logo} alt="Logo Retro IA" className="w-25 h-auto" />
    </div>
  );
}
